import React from 'react';

interface CurrentStateQuestionsProps {
  responses: Record<string, any>;
  onChange: (responses: Record<string, any>) => void;
}

export function CurrentStateQuestions({ responses, onChange }: CurrentStateQuestionsProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Your Current Situation</h2>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="current_role" className="block text-sm font-medium text-gray-700">
            What is your current role?
          </label>
          <input
            type="text"
            id="current_role"
            value={responses.current_role || ''}
            onChange={(e) => onChange({ current_role: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          />
        </div>

        <div>
          <label htmlFor="experience" className="block text-sm font-medium text-gray-700">
            Years of experience
          </label>
          <select
            id="experience"
            value={responses.experience || ''}
            onChange={(e) => onChange({ experience: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select years of experience</option>
            <option value="0-1">0-1 years</option>
            <option value="1-3">1-3 years</option>
            <option value="3-5">3-5 years</option>
            <option value="5-10">5-10 years</option>
            <option value="10+">10+ years</option>
          </select>
        </div>

        <div>
          <label htmlFor="satisfaction" className="block text-sm font-medium text-gray-700">
            How satisfied are you with your current role?
          </label>
          <select
            id="satisfaction"
            value={responses.satisfaction || ''}
            onChange={(e) => onChange({ satisfaction: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select satisfaction level</option>
            <option value="very_satisfied">Very Satisfied</option>
            <option value="satisfied">Satisfied</option>
            <option value="neutral">Neutral</option>
            <option value="dissatisfied">Dissatisfied</option>
            <option value="very_dissatisfied">Very Dissatisfied</option>
          </select>
        </div>
      </div>
    </div>
  );
}